/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { MilkJson } from '@/types/domain/milk/entities/milkEntity';
import type { MilkStateType } from '@/types/domain/milk/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: MilkStateType = {
  milkList: [],
  nextToken: null,
};

/**
 * ミルクSlice
 */
export const milkSlice = createSlice({
  name: 'milk',
  initialState,
  reducers: {
    /** ミルクリストをセット */
    setMilkList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: MilkJson[],
      }>) => {
        state.milkList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** ミルクストア作成 */
    createMilkStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.milkList = service.milk.createMilkStore(
        state.milkList,
        action.payload,
        undefined,
      );
    },
    /** ミルクストア更新 */
    updateMilkStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.milkList = service.milk.updateMilkStore(
        state.milkList,
        action.payload,
      );
    },
    /** ミルクストア削除 */
    deleteMilkStore: (state, action: PayloadAction<DeleteOutputType>) => {
      state.milkList = service.milk.deleteMilkStore(
        state.milkList,
        action.payload,
      );
    },
  },
});
